import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ApplicationContentReducer(state = initialState.applicationContent, action: any) {
  switch (action.type) {
    case types.SAVE_APPLICATIONCONTENT_SUCCESS:
      return action.applicationContent;
    default:
      return state;
  }
}
